/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable multiline-ternary */
import React, { useEffect, useState } from 'react'
import Slider from '@mui/material/Slider'
import { Typography } from '@mui/material'
import { PropTypes } from 'prop-types'
import Grid from '@mui/material/Grid'
import { useDispatch, useSelector } from 'react-redux'
import config from '../../config/config'
import {
  AUTO,
  BICYCLE,
  FREIGHT,
  MODAL_TIERS,
  PEDESTRIAN,
  TRANSIT
} from '../../constants/modalTiers'
import { setModalTiers } from '../../slices/generalInputs/modalTiers'
import { setRoadwayVariables } from '../../slices/generalInputs/roadwayVariables'
import {
  AVG_DAILY_TRAFFIC,
  ROADWAY_VARIABLES
} from '../../constants/roadwayVariables'
import { SubSectionTitle } from './ProjectInputs'
import { remixStreet } from '../../../streets/remix'
import { setShareableURL } from '../../slices/appSlice'
const pedestrianIcon = new URL(
  '../../../../images/icons/pedestrian.svg',
  import.meta.url
)
const transitIcon = new URL(
  '../../../../images/icons/transit.svg',
  import.meta.url
)
const autoIcon = new URL('../../../../images/icons/auto.svg', import.meta.url)
const freightIcon = new URL(
  '../../../../images/icons/freight.svg',
  import.meta.url
)
const bicycleIcon = new URL(
  '../../../../images/icons/bicycle.svg',
  import.meta.url
)

export const getIcon = (field) => {
  switch (field) {
    case PEDESTRIAN:
      return pedestrianIcon

    case AUTO:
      return autoIcon

    case FREIGHT:
      return freightIcon

    case TRANSIT:
      return transitIcon

    case BICYCLE:
      return bicycleIcon

    default:
  }
}

function getTrafficSliderVal(value) {
  switch (value) {
    case '<5000':
      return 0
    case '5001-10,000':
      return 5
    case '10,001-20,000':
      return 10
    case '20,001-30,000':
      return 15
    case '30,001-40,000':
      return 20
    case '40,001-50,000':
      return 25
    case '50,001-60,000':
      return 30
    case '60,001-70,000':
      return 35
    case '70,001-80,000':
      return 40
    case '>=80,001':
      return 45
    default:
  }
}

function getTrafficRange(value) {
  switch (value) {
    case 0:
      return '<5000'
    case 5:
      return '5001-10,000'
    case 10:
      return '10,001-20,000'
    case 15:
      return '20,001-30,000'
    case 20:
      return '30,001-40,000'
    case 25:
      return '40,001-50,000'
    case 30:
      return '50,001-60,000'
    case 35:
      return '60,001-70,000'
    case 40:
      return '70,001-80,000'
    case 45:
      return '>=80,001'
    default:
  }
}

function getModalTierSliderVal(value) {
  switch (value) {
    case 'N/A':
      return 0
    case 0:
      return 0
    case 3:
      return 1
    case 2:
      return 2
    case 1:
      return 3
    default:
  }
}

function getModalTierVal(value) {
  switch (value) {
    case 0:
      return 'N/A'
    case 1:
      return 3
    case 2:
      return 2
    case 3:
      return 1
    default:
  }
}

export default function CustomSlider({
  step,
  sliderNote,
  notesLink,
  min,
  max,
  field,
  sliderType,
  question,
  format = ''
}) {
  const inputValue = useSelector((state) => state[sliderType][field])
  const { shareableURL } = useSelector((state) => state.appSlice)
  const dispatch = useDispatch()
  const [localValue, setLocalValue] = useState(
    field !== AVG_DAILY_TRAFFIC ? inputValue : getTrafficSliderVal(inputValue)
  )

  function handleChange(e, newValue) {
    // If URL is shareable, then remix street whenever a field is changed
    if (shareableURL) {
      // remixStreet() -> street remix is done is App.jsx whenever shareableURL is false
      dispatch(setShareableURL(false))
    }
    setLocalValue(newValue)
    switch (sliderType) {
      case MODAL_TIERS:
        dispatch(
          setModalTiers({ field, value: getModalTierSliderVal(newValue) })
        )
        break
      case ROADWAY_VARIABLES:
        // If field is avg.daily traffic update formatted values, instead of value from slider
        field === AVG_DAILY_TRAFFIC
          ? dispatch(
              setRoadwayVariables({ field, value: getTrafficRange(newValue) })
            )
          : dispatch(setRoadwayVariables({ field, value: newValue }))
        break
      default:
    }
  }
  const valueLabelFormat = (value) => {
    switch (format) {
      case '':
        return value
      case 'speed':
        return `${value}MPH`
      case 'traffic':
        return getTrafficRange(value)
      case 'modalTiers':
        return getModalTierVal(value)
      default:
    }
  }

  useEffect(() => {
    // Update redux state when component mounts , with default values
    switch (sliderType) {
      case MODAL_TIERS:
        setLocalValue(getModalTierSliderVal(inputValue))
        break
      case ROADWAY_VARIABLES:
        // If field is avg.daily traffic update formatted values, instead of value from slider

        field === AVG_DAILY_TRAFFIC
          ? setLocalValue(getTrafficSliderVal(inputValue))
          : setLocalValue(inputValue)
        break
      default:
    }
  }, [inputValue])

  return (
    <Grid
      container={true}
      spacing={4}
      width="90%"
      alignItems={sliderType === 'modalTiers' ? 'center' : 'stretch'}
      direction={sliderType === 'modalTiers' ? 'row' : 'column'}
      sx={{
        ml: '0px !important',
        mt: sliderType === 'modalTiers' ? '-22px !important' : '-32px '
      }}
    >
      {sliderType === 'modalTiers' ? (
        <Grid item={true} sx={{ pt: '0px !important', pl: '0px !important' }}>
          <img
            src={getIcon(field)}
            alt={`${field}image`}
            style={{ width: '30px', height: '30px' }}
          />
        </Grid>
      ) : (
        <Grid item={true}>
          <SubSectionTitle>{question}</SubSectionTitle>
        </Grid>
      )}
      <Grid item={true} xs={true} mb="8px">
        <Slider
          marks={true}
          aria-label="Default"
          value={localValue}
          step={step}
          min={min}
          max={max}
          onChange={handleChange}
          valueLabelFormat={valueLabelFormat}
          valueLabelDisplay="on"
          sx={{
            color: config.themeConfig.semcogGreen,
            p: 0,
            '& .MuiSlider-thumb': {
              width: 8,
              height: 12,
              borderRadius: 0
            },
            '& .MuiSlider-valueLabel': {
              backgroundColor: 'black',
              fontWeight: 900
            },
            '& .MuiSlider-rail': {
              color: config.themeConfig.semcogLightGray,
              height: 6
            }
          }}
        />
        <Typography
          gutterBottom={true}
          sx={{
            mt: 0,
            ml: 3,
            fontSize: '13px',
            color: config.themeConfig.lightTextColor
          }}
        >
          {sliderNote.includes('/') ? (
            <span>
              {sliderNote.split('/')[0]} /{' '}
              <a href={notesLink} target="blank">
                {sliderNote.split('/')[1]}
              </a>
            </span>
          ) : (
            sliderNote
          )}
        </Typography>
      </Grid>
    </Grid>
  )
}
CustomSlider.propTypes = {
  step: PropTypes.number.isRequired,
  sliderNote: PropTypes.string.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  field: PropTypes.string.isRequired,
  sliderType: PropTypes.string.isRequired,
  question: PropTypes.string,
  format: PropTypes.string,
  notesLink: PropTypes.string
}
